import { render } from "./CustomerList.vue?vue&type=template&id=866dd7a0&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=866dd7a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866dd7a0"]])

export default __exports__